import Dinero from "dinero.js"

export default {
  methods: {
    money(amount) {
      return Dinero({
        currency: "EUR",
        amount: Math.round(amount * 100)
      }).setLocale("it-IT")
    },
    calculateDifference(first, second, amount) {
      first = this.money(first).multiply(amount)
      second = this.money(second).multiply(amount)
      try {
        if (first.greaterThan(second)) {
          let difference = first.subtract(second)
          let differencePercentage =
            (difference.getAmount() / first.getAmount()) * 100
          return [
            difference.toFormat(),
            differencePercentage.toFixed(2).replace(".", ",")
          ]
        } else {
          return null
        }
      } catch (TypeError) {}
    },
    formatDifference(...args) {
      let diff = this.calculateDifference(...args)
      if (diff) {
        return `${diff[0]} (${diff[1]}%)`
      } else {
        return "N/A"
      }
    }
  }
}
